type JsonValue = Record<string, unknown> | unknown[] | null | undefined;

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const deepEqual = (a: unknown, b: unknown): boolean => {
  if (Object.is(a, b)) {
    return true;
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, index) => deepEqual(item, b[index]));
  }
  if (isObject(a) && isObject(b)) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    return aKeys.every((key) => deepEqual(a[key], b[key]));
  }
  return false;
};

export const diffPaths = (a: unknown, b: unknown, basePath = ''): string[] => {
  if (deepEqual(a, b)) {
    return [];
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    const maxLen = Math.max(a.length, b.length);
    const paths: string[] = [];
    for (let index = 0; index < maxLen; index += 1) {
      paths.push(...diffPaths(a[index], b[index], `${basePath}[${index}]`));
    }
    return paths;
  }
  if (isObject(a) && isObject(b)) {
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    const paths: string[] = [];
    keys.forEach((key) => {
      const nextPath = basePath ? `${basePath}.${key}` : key;
      paths.push(...diffPaths(a[key], b[key], nextPath));
    });
    return paths;
  }
  return [basePath || '$'];
};

